exports.install = function(Vue, options) {
    Vue.prototype.getFY = function(date) {
        const year = Number(date.slice(0, 4));
        const month = Number(date.slice(5, 7));
        const FY = [];

        for (let i = 0; i < 18; i++) {
            if (month + i > 12) {
                let temp = month + i - 12;

                if (temp < 10) {
                    temp = '0' + temp.toString();
                }
                FY.push({
                    headerName: `${year + 1}-${temp}`,
                    field: `month${i + 1}`
                });
            } else {
                let temp = month + i;

                if (temp < 10) {
                    temp = '0' + temp.toString();
                }
                FY.push({
                    headerName: `${year}-${temp}`,
                    field: `month${i + 1}`
                });
            }
        }
        return FY;
    };
    Vue.prototype.getFYSum = function(date) {
        let year = Number(date.slice(0, 4));
        const month = Number(date.slice(5, 7));

        if (month >= 7) {
            year = year + 1;
        }
        const FYSum = [];
        const lastYearHeader = `FY${(year - 1)
            .toString()
            .substring(2)}${year.toString().substring(2)}`;
        const nextYearHeader = `FY${year.toString().substring(2)}${(year + 1)
            .toString()
            .substring(2)}`;

        FYSum.push(
            {
                headerName: lastYearHeader + ' (MSU)',
                field: 'month19FY',
                editable: false
            },
            {
                headerName: nextYearHeader + ' (MSU)',
                field: 'month20FY',
                editable: false
            }
        );
        return FYSum;
    };
    Vue.prototype.ABM = function() {
        return sessionStorage.getItem('userRole').includes('ABM');
    };
    Vue.prototype.MP = function() {
        return sessionStorage.getItem('userRole').includes('MP');
    };
    Vue.prototype.DP = function() {
        return sessionStorage.getItem('userRole').includes('DP');
    };
};



// WEBPACK FOOTER //
// ./src/base.js